import GiftDetailsDialog from "./giftDetailsDialog.container";

export default GiftDetailsDialog;
